import { render, staticRenderFns } from "./SystemAcceptBets.vue?vue&type=template&id=4cd9359d&scoped=true&"
import script from "./SystemAcceptBets.vue?vue&type=script&lang=js&"
export * from "./SystemAcceptBets.vue?vue&type=script&lang=js&"
import style0 from "./SystemAcceptBets.vue?vue&type=style&index=0&id=4cd9359d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd9359d",
  null
  
)

export default component.exports